module.exports = (__webpack_require__(76))(2);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/object-assign/index.js from dll-reference vendor
// module id = 129
// module chunks = 0